export { default } from './src/RichText';
export * from './src/types.d';
export { default as richTextStyles } from './src/RichText.styles';
